import * as angular from "angular";
import {IQService, IWindowService} from "angular";
import {AgentsAlerts} from "./agents-alerts.service";
import {SplitService} from "../../commons/services/split-service.service";

export class AgentsContextService {

  constructor(private $window: IWindowService,
              private $q: IQService,
              private splitService: SplitService,
              private agentsAlerts: AgentsAlerts) {
  }

  getFavouriteAgentIds(siteId?: string): string[] {
    if (!siteId) {
      siteId = this.splitService.getSiteId();
    }

    const agentsContext = angular.fromJson(this.$window.localStorage.getItem('favouriteAgentsContext'));
    return agentsContext && agentsContext[siteId] ? agentsContext[siteId] : [];
  }

  setFavouriteAgentIds(agentIds: string[], siteId?: string) {

    if (agentIds.length > 30) {
      this.agentsAlerts.saveFavouriteError(30);
      return false;
    }

    if (!siteId) {
      siteId = this.splitService.getSiteId();
    }

    let agentsContext = angular.fromJson(this.$window.localStorage.getItem('favouriteAgentsContext'));

    if (!agentsContext) {
      agentsContext = {};
    }

    agentsContext[siteId] = agentIds;
    this.$window.localStorage.setItem('favouriteAgentsContext', angular.toJson(agentsContext));
    this.agentsAlerts.saveFavouriteSuccess();
    return true;
  }
}


angular
  .module('bringoz.admin.agents')
  .service('agentsContextService', AgentsContextService);
